import { CardDescriptionProps } from './CardDescription.model';
import css from './CardDescription.module.scss';
import { Text } from '@epam/promo';
import React from 'react';

export const CardDescription = ({ description }: CardDescriptionProps) => (
  <Text
    color="gray90"
    cx={css['card-description']}
    fontSize="12"
    lineHeight="24"
    rawProps={{
      'data-testid': 'card-description',
    }}
    size="24">
    {description || 'Description'}
  </Text>
);
